import React from "react";
import { ShieldOff } from "lucide-react";
import { TooltipProvider } from "../../Franchise/D2CDashboard/ui/tooltip";
import "../../Franchise/D2CDashboard/ui/tailwind.css";

// The page root of the All warranties screens, the same frame as the D2C fulfilment screens: the
// d2c-ui class scopes the Tailwind tokens, and tooltips work in portals too.
export const Shell = ({ children }) => (
  <TooltipProvider delayDuration={200}>
    <section
      data-warranty-root=""
      className="Main_section d2c-ui tw-float-left tw-h-full tw-w-full tw-overflow-y-auto tw-overflow-x-hidden tw-rounded-lg tw-bg-page tw-p-4 tw-font-sans tw-text-sm tw-leading-5 tw-text-foreground tw-antialiased"
    >
      {children}
    </section>
  </TooltipProvider>
);

export const PageHeader = ({ title, sub, actions, children }) => (
  <header className="tw-mb-4 tw-flex tw-flex-wrap tw-items-start tw-justify-between tw-gap-3">
    <div className="tw-min-w-0">
      <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
        <h1 className="tw-m-0 tw-font-sans tw-text-xl tw-font-semibold tw-leading-7 tw-tracking-tight tw-text-foreground">
          {title}
        </h1>
        {children}
      </div>
      {sub && <p className="tw-m-0 tw-mt-0.5 tw-text-sm tw-text-muted-foreground">{sub}</p>}
    </div>
    {actions && <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">{actions}</div>}
  </header>
);

// `children` says who may open the screen; the All warranties sentence when not given.
export const NoWarrantyAccess = ({ children }) => (
  <div className="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-dashed tw-bg-background tw-px-6 tw-py-14 tw-text-center">
    <div className="tw-flex tw-size-11 tw-items-center tw-justify-center tw-rounded-full tw-bg-muted">
      <ShieldOff className="tw-size-5 tw-text-muted-foreground" aria-hidden="true" />
    </div>
    <strong className="tw-text-base tw-font-semibold tw-text-foreground">You don't have access</strong>
    <span className="tw-max-w-sm tw-text-sm tw-text-muted-foreground">
      {children || "All warranties is open to super admins and users with the Warranty Review Queue permission."}
    </span>
  </div>
);
